"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cyclabilities = exports.bnacFacilitiesMap = exports.UserTracesStats = exports.Suggestion = exports.StatsTypes = exports.SectionStats = exports.GeogroupStats = exports.DiscontinuityResolution = exports.Discontinuity = exports.ComputedRouteStats = exports.ApiStats = exports.ActivityStats = void 0;
exports.distanceTransform = distanceTransform;
exports.durationTransform = durationTransform;
exports.roadTypesLabels = void 0;
exports.savedCO2Transform = savedCO2Transform;
exports.userStats = void 0;
var _icons = require("../components/icons");
var _environment = require("../environment");
const cyclabilities = exports.cyclabilities = ['veryGood', 'good', 'neutral', 'bad', 'veryBad'];
class Discontinuity {
  constructor(id, sectionId, index, isOnward, cyclability, beforeFacility, contactFacility, tracesCount, discontinuityTracesCount, resolutions) {
    this.id = id;
    this.sectionId = sectionId;
    this.index = index;
    this.isOnward = isOnward;
    this.cyclability = cyclability;
    this.beforeFacility = beforeFacility;
    this.contactFacility = contactFacility;
    this.tracesCount = tracesCount;
    this.discontinuityTracesCount = discontinuityTracesCount;
    this.resolutions = resolutions;
  }
}
exports.Discontinuity = Discontinuity;
class DiscontinuityResolution {
  constructor(sections, score, distance) {
    this.sections = sections;
    this.score = score;
    this.distance = distance;
  }
}
exports.DiscontinuityResolution = DiscontinuityResolution;
class Suggestion {
  constructor(id, created, model, title, partner_id, budget, start_date, end_date, resolution_date) {
    this.id = id;
    this.created = created;
    this.model = model;
    this.title = title;
    this.partner_id = partner_id;
    this.budget = budget;
    this.start_date = start_date;
    this.end_date = end_date;
    this.resolution_date = resolution_date;
  }
}
exports.Suggestion = Suggestion;
class SectionStats {
  constructor(sectionId, frequencyBackward, frequencyOnward, averageSpeedBackward, averageSpeedOnward, roughnessesBackward, roughnessesOnward, extrapolation, distanceBackward, distanceOnward, date, discontinuityOnwardId, discontinuityBackwardId, discontinuityOnwardIndex, discontinuityBackwardIndex, contactFacilityOnward, contactFacilityBackward, beforeFacilityOnward, beforeFacilityBackward, cyclabilityOnward, cyclabilityBackward, tracesCountOnward, tracesCountBackward, discontinuityTracesCountOnward, discontinuityTracesCountBackward, isOnward, isBackward, customColor, isResolution) {
    this.sectionId = sectionId;
    this.frequencyBackward = frequencyBackward;
    this.frequencyOnward = frequencyOnward;
    this.averageSpeedBackward = averageSpeedBackward;
    this.averageSpeedOnward = averageSpeedOnward;
    this.roughnessesBackward = roughnessesBackward;
    this.roughnessesOnward = roughnessesOnward;
    this.extrapolation = extrapolation;
    this.distanceBackward = distanceBackward;
    this.distanceOnward = distanceOnward;
    this.date = date;
    this.discontinuityOnwardId = discontinuityOnwardId;
    this.discontinuityBackwardId = discontinuityBackwardId;
    this.discontinuityOnwardIndex = discontinuityOnwardIndex;
    this.discontinuityBackwardIndex = discontinuityBackwardIndex;
    this.contactFacilityOnward = contactFacilityOnward;
    this.contactFacilityBackward = contactFacilityBackward;
    this.beforeFacilityOnward = beforeFacilityOnward;
    this.beforeFacilityBackward = beforeFacilityBackward;
    this.cyclabilityOnward = cyclabilityOnward;
    this.cyclabilityBackward = cyclabilityBackward;
    this.tracesCountOnward = tracesCountOnward;
    this.tracesCountBackward = tracesCountBackward;
    this.discontinuityTracesCountOnward = discontinuityTracesCountOnward;
    this.discontinuityTracesCountBackward = discontinuityTracesCountBackward;
    this.isOnward = isOnward;
    this.isBackward = isBackward;
    this.customColor = customColor;
    this.isResolution = isResolution;
  }
}
exports.SectionStats = SectionStats;
const bnacFacilitiesMap = exports.bnacFacilitiesMap = {
  'autre chemin velo uni': 'other',
  'bande bi': 'lane',
  'bande uni': 'lane',
  'chemin dedie uni': 'mixedfacilities',
  'chemin service site propre uni': 'other',
  'cheminement trottoir uni': 'mixedfacilities',
  'cheminement uni': 'other',
  'DSC bande': 'opposite',
  'DSC piste': 'opposite',
  'piste bi': 'cycleway',
  'piste trottoir uni': 'cycleway',
  'piste uni': 'cycleway',
  'shoulder uni': 'other',
  'voie bus bi': 'sharebusway',
  'voie bus uni': 'sharebusway',
  'voie verte uni': 'greenway',
  bicycle_no: 'forbidden',
  chaucidou: 'other',
  DSC: 'opposite',
  goulotte: 'other',
  velorue: 'other'
};
const roadTypesLabels = exports.roadTypesLabels = {
  cycleway: 'commons.road_types.cycleway',
  footway: 'commons.road_types.footway',
  living_street: 'commons.road_types.living_street',
  path: 'commons.road_types.path',
  pedestrian: 'commons.road_types.pedestrian',
  primary: 'commons.road_types.primary',
  primary_link: 'commons.road_types.primary_link',
  residential: 'commons.road_types.residential',
  secondary: 'commons.road_types.secondary',
  secondary_link: 'commons.road_types.secondary_link',
  service: 'commons.road_types.service',
  tertiary: 'commons.road_types.tertiary',
  tertiary_link: 'commons.road_types.tertiary_link',
  track: 'commons.road_types.track',
  trunk: 'commons.road_types.trunk',
  trunk_link: 'commons.road_types.trunk_link',
  unclassified: 'commons.road_types.unclassified'
};
class GeogroupStats {
  constructor(nbMembers, data) {
    this.nbMembers = nbMembers;
    this.data = data;
  }
}
exports.GeogroupStats = GeogroupStats;
class ActivityStats {
  constructor(nbComputedRoutes, distance, duration, nbRoutes, data, homeWorkDistance, homeWorkDuration, homeWorkJourneys, homeWorkSavedCO2InKg, nbActiveUsers, nbActiveUsersWithHomeWorkTrace) {
    this.nbComputedRoutes = nbComputedRoutes;
    this.distance = distance;
    this.duration = duration;
    this.nbRoutes = nbRoutes;
    this.data = data;
    this.homeWorkDistance = homeWorkDistance;
    this.homeWorkDuration = homeWorkDuration;
    this.homeWorkJourneys = homeWorkJourneys;
    this.homeWorkSavedCO2InKg = homeWorkSavedCO2InKg;
    this.nbActiveUsers = nbActiveUsers;
    this.nbActiveUsersWithHomeWorkTrace = nbActiveUsersWithHomeWorkTrace;
  }
}
exports.ActivityStats = ActivityStats;
class ComputedRouteStats {
  constructor(count, distance, data) {
    this.count = count;
    this.distance = distance;
    this.data = data;
  }
}
exports.ComputedRouteStats = ComputedRouteStats;
class UserTracesStats {
  constructor(count, homeWorkCount, distance, homeWorkDistance, duration, homeWorkDuration, homeWorkSavedCO2InKg, averageSpeed, verticalGain, data) {
    this.count = count;
    this.homeWorkCount = homeWorkCount;
    this.distance = distance;
    this.homeWorkDistance = homeWorkDistance;
    this.duration = duration;
    this.homeWorkDuration = homeWorkDuration;
    this.homeWorkSavedCO2InKg = homeWorkSavedCO2InKg;
    this.averageSpeed = averageSpeed;
    this.verticalGain = verticalGain;
    this.data = data;
  }
}
exports.UserTracesStats = UserTracesStats;
class ApiStats {
  constructor(date, stats) {
    this.date = date;
    this.stats = stats;
  }
}
exports.ApiStats = ApiStats;
let StatsTypes = exports.StatsTypes = /*#__PURE__*/function (StatsTypes) {
  StatsTypes[StatsTypes["Count"] = 1] = "Count";
  StatsTypes[StatsTypes["Distance"] = 2] = "Distance";
  StatsTypes[StatsTypes["Duration"] = 3] = "Duration";
  StatsTypes[StatsTypes["VerticalGain"] = 4] = "VerticalGain";
  StatsTypes[StatsTypes["AverageSpeed"] = 5] = "AverageSpeed";
  return StatsTypes;
}({});
const userStats = exports.userStats = [{
  color: '#733be9',
  type: StatsTypes.Count,
  titleKey: 'commons.stats_types.journeys',
  Icon: _icons.PlaceIcon,
  transform: value => value || value === 0 ? value.toString() : '-'
}, {
  color: '#f3b76f',
  type: StatsTypes.Distance,
  titleKey: 'commons.stats_types.distance',
  Icon: _icons.DistanceIcon,
  transform: distanceTransform
}, {
  color: '#03966a',
  type: 'SavedCO2',
  titleKey: 'commons.routing.detail.co2_saved',
  Icon: _icons.SavedCO2Icon,
  transform: savedCO2Transform
}, {
  color: '#dd428d',
  type: StatsTypes.Duration,
  titleKey: 'commons.stats_types.duration',
  Icon: _icons.DurationIcon,
  transform: durationTransform
}, {
  color: '#a86d38',
  type: StatsTypes.VerticalGain,
  titleKey: 'commons.stats_types.vertical_gain',
  Icon: _icons.VerticalGainIcon,
  transform: value => value || value === 0 ? `${value} m` : '-'
}, {
  color: '#28a5db',
  type: StatsTypes.AverageSpeed,
  titleKey: 'commons.stats_types.average_speed',
  Icon: _icons.SpeedIcon,
  transform: value => value || value === 0 ? `${value.toFixed(0)} km/h` : '-'
}];
function distanceTransform(value) {
  if (!value && value !== 0) {
    return '-';
  }
  if (value >= 1000) {
    return `${(value / 1000).toFixed(1)} km`;
  }
  return `${Math.round(value / 50) * 50} m`;
}
function savedCO2Transform(distance) {
  if (!distance && distance !== 0) {
    return '-';
  }
  return `${(distance / 1000 * _environment.defaultEnvironment.savedKgOfCO2PerKilometer).toFixed(1)} kg`;
}
function durationTransform(value) {
  if (!value && value !== 0) {
    return '-';
  }
  let negative = false;
  if (value < 0) {
    value = -value;
    negative = true;
  }
  return parseToHourMinutes(value, negative);
}
function parseToHourMinutes(value, negative) {
  const minutes = Math.round(value % 3600 / 60);
  if (value >= 3600) {
    const hours = Math.floor(value / 3600);
    if (minutes === 0) {
      return negative ? `-${hours} h` : `${hours} h`;
    } else if (minutes === 60) {
      return negative ? `-${hours + 1} h` : `${hours + 1} h`;
    } else {
      return negative ? `-${hours} h ${minutes} min` : `${hours} h ${minutes} min`;
    }
  } else {
    return negative ? `-${minutes} min` : `${minutes} min`;
  }
}